module.exports = __webpack_public_path__ + "img/main_review_img_02.b4ae87fd.png";